import React, { useState } from 'react'
import { disqualifyParticipantMounted } from '../ParticipantsTable/model'
import {
  CButton,
  CCol,
  CFormLabel,
  CFormTextarea,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from '@coreui/react-pro'

type Props = {
  id: string
  isVisible: boolean
  onClose: () => void
}

export const DisqualifyParticipantModal: React.FC<Props> = ({
  id,
  isVisible,
  onClose,
}) => {
  const [reason, setReason] = useState<string>('')

  const handleSubmit = () => {
    disqualifyParticipantMounted({
      id,
      reason: reason,
    })
    setReason('')
    onClose()
  }

  return (
    <CModal visible={isVisible} onClose={onClose} size={'lg'}>
      <CModalHeader>
        <CModalTitle>Set disqualify participant reason</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CRow>
          <CCol xs={9}>
            <div className="mb-4">
              <CFormLabel className="fw-bold">Enter a reason</CFormLabel>
              <CFormTextarea
                name="reason"
                placeholder="reason"
                value={reason}
                onChange={(e) => {
                  setReason(e.target.value)
                }}
              />
            </div>
          </CCol>
        </CRow>
        <CModalFooter>
          <CButton
            color="secondary"
            onClick={() => {
              onClose()
              setReason('')
            }}
          >
            Cancel
          </CButton>
          <CButton color="primary" className="px-4" onClick={handleSubmit}>
            Ok
          </CButton>
        </CModalFooter>
      </CModalBody>
    </CModal>
  )
}
